module.exports = __webpack_public_path__ + "static/media/code3.781e5519.jpg";